"use client";
import LogInComponent from "@/components/auth/LoginComponents";
import React, { Suspense, useEffect } from "react";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { trackPageView } from "@/utils/sentryClientErrorTracking";

const LoginPage = () => {
  useEffect(() => {
    // Track page view for debugging
    trackPageView("Login Page");
  }, []);

  return (
    <ErrorBoundary pageName="Login Page">
      <Suspense fallback={<div>Loading...</div>}>
        <LogInComponent />
      </Suspense>
    </ErrorBoundary>
  );
};

export default LoginPage;
